import React, { useState, useEffect } from "react";
import supabase from "../utils/supabase";
import { HashLoader } from "react-spinners";

function UserDetailsVerify() {
  const [description, setDescription] = useState("");
  const [userRole, setUserRole] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchUserRole() {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (user) {
        const { data, error } = await supabase
          .from("users")
          .select("role")
          .eq("id", user.id)
          .single();

        if (data) {
          setUserRole(data.role);
        }
      }
      setIsLoading(false);
    }
    fetchUserRole();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <HashLoader color="#0072ff" size={50} />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4 sm:py-8">
      {/* Header */}
      <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-6 sm:mb-8">
        Add Details To Get Verified
      </h1>

      {/* Form */}
      <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg w-full sm:max-w-sm md:max-w-md lg:max-w-lg">
        <form>
          {/* Mobile Number Input */}
          <div className="mb-4">
            <label
              htmlFor="mobile-number"
              className="block text-sm sm:text-base md:text-lg text-gray-800 font-medium mb-2"
            >
              Mobile Number
            </label>
            <input
              type="text"
              id="mobile-number"
              name="mobile-number"
              className="w-full p-3 text-sm sm:text-base md:text-lg border border-[#0072ff] rounded-md focus:outline-none focus:ring-2 focus:ring-[#0072ff]"
              placeholder="Enter your mobile number"
              required
            />
          </div>

          {/* Dropdown */}
          <div className="mb-4">
            <label
              htmlFor="description"
              className="block text-sm sm:text-base md:text-lg text-gray-800 font-medium mb-2"
            >
              Which of these best describes you?
            </label>
            <select
              id="description"
              name="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full p-3 text-sm sm:text-base md:text-lg border border-[#0072ff] bg-transparent rounded-md focus:outline-none focus:ring-2 focus:ring-[#0072ff]"
              required
            >
              <option value="">Select an option</option>
              <option value="student">Student</option>
              <option value="professional">Professional</option>
              <option value="other">Other</option>
            </select>
          </div>

          {/* Conditional Other Description Input */}
          {description === "other" && (
            <div className="mb-4">
              <label
                htmlFor="other-description"
                className="block text-sm sm:text-base md:text-lg text-gray-800 font-medium mb-2"
              >
                Please specify
              </label>
              <input
                type="text"
                id="other-description"
                name="other-description"
                className="w-full p-3 text-sm sm:text-base md:text-lg border border-[#0072ff] rounded-md focus:outline-none focus:ring-2 focus:ring-[#0072ff]"
                placeholder="Enter your description"
                required
              />
            </div>
          )}

          {/* Country of Citizenship */}
          <div className="mb-4">
            <label
              htmlFor="citizenship"
              className="block text-sm sm:text-base md:text-lg text-gray-800 font-medium mb-2"
            >
              Country of citizenship
            </label>
            <input
              type="text"
              id="citizenship"
              name="citizenship"
              className="w-full p-3 text-sm sm:text-base md:text-lg border border-[#0072ff] rounded-md focus:outline-none focus:ring-2 focus:ring-[#0072ff]"
              placeholder="Enter your country"
              required
            />
          </div>

          {/* Location */}
          <div className="mb-4">
            <label
              htmlFor="location"
              className="block text-sm sm:text-base md:text-lg text-gray-800 font-medium mb-2"
            >
              Location
            </label>
            <input
              type="text"
              id="location"
              name="location"
              className="w-full p-3 text-sm sm:text-base md:text-lg border border-[#0072ff] rounded-md focus:outline-none focus:ring-2 focus:ring-[#0072ff]"
              placeholder="Enter your location"
              required
            />
          </div>

          {/* Conditional PAN/Aadhar Input */}
          <div className="mb-6">
            <label
              htmlFor={userRole === "Startup Founder" ? "aadhar" : "pan"}
              className="block text-sm sm:text-base md:text-lg text-gray-800 font-medium mb-2"
            >
              {userRole === "Startup Founder"
                ? "Aadhar Number"
                : "PAN (Permanent Account Number)"}
            </label>
            <input
              type="text"
              id={userRole === "Startup Founder" ? "aadhar" : "pan"}
              name={userRole === "Startup Founder" ? "aadhar" : "pan"}
              className="w-full p-3 text-sm sm:text-base md:text-lg border border-[#0072ff] rounded-md focus:outline-none focus:ring-2 focus:ring-[#0072ff]"
              placeholder={
                userRole === "Startup Founder"
                  ? "Enter your Aadhar number"
                  : "Enter your PAN"
              }
              required
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-[#0072ff] text-white text-sm sm:text-base md:text-lg font-bold py-3 px-4 rounded-lg hover:bg-[#0052cc] transition-colors"
          >
            Next
          </button>
        </form>
      </div>
    </div>
  );
}

export default UserDetailsVerify;
